import axios from "axios";

const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

const api = axios.create({
  baseURL: base ? `${base}/api` : "/api",
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/** Garante array mesmo se a API devolver HTML/objeto (ex.: deploy antigo sem /api). */
export function asList(data) {
  return Array.isArray(data) ? data : [];
}

export function asProduct(data) {
  if (!data || typeof data !== "object" || Array.isArray(data) || !data.id) return null;
  return {
    ...data,
    ingredients: Array.isArray(data.ingredients) ? data.ingredients : [],
    benefits: Array.isArray(data.benefits) ? data.benefits : [],
  };
}

export const brl = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);

export default api;
